import track from "../track";
import sdkProvider from "../sdkProvider";
import mapGlobalsToAppMeasurementInstance from "../mapGlobalsToAppMeasurementInstance";
import mapToAppMeasurementInstance from "./mapToAppMeasurementInstance";
import mapToOverridesAndSetGlobalsAsVars from "./mapToOverridesAndSetGlobalsAsVars";
import mapToLinkName from "./mapToLinkName";

import { ADOBE_LINK_TYPE_CUSTOM_LINK } from "../constants";

const getBoundMethod = (
  appMeasurementInstance,
  trackLink,
  linkName,
  overrides
) => {
  const noHrefThisVariable = true;
  const linkType = ADOBE_LINK_TYPE_CUSTOM_LINK;

  return trackLink.bind(
    appMeasurementInstance,
    noHrefThisVariable,
    linkType,
    linkName,
    overrides
  );
};

export default ({ state }) => {
  const mappedGlobals = mapGlobalsToAppMeasurementInstance(state);
  const overrides = mapToOverridesAndSetGlobalsAsVars(state, mappedGlobals);
  const linkName = mapToLinkName(state);
  const { appMeasurementInstance, trackLink } = sdkProvider();
  const sdkMethod = getBoundMethod(
    appMeasurementInstance,
    trackLink,
    linkName,
    overrides
  );
  track({
    sdkMethod,
    instancePayload: {
      ...mapToAppMeasurementInstance(state),
      ...mappedGlobals
    }
  });
};
